import type { ReactNode } from 'react';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

interface BenefitsTableColumn {
  header: ReactNode;
  align?: 'left' | 'center' | 'right';
}

interface BenefitsTableProps {
  columns: BenefitsTableColumn[];
  rows: Array<{
    key: string;
    cells: ReactNode[];
  }>;
  emptyMessage?: string;
}

export const BenefitsTable = ({
  columns,
  rows,
  emptyMessage = 'No data available.',
}: BenefitsTableProps) => {
  if (rows.length === 0) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8 vai-bg-gray-50 vai-rounded-lg">
        {emptyMessage}
      </div>
    );
  }

  const getAlignmentClass = (align: BenefitsTableColumn['align']) => {
    switch (align) {
      case 'center':
        return 'vai-text-center';
      case 'right':
        return 'vai-text-right';
      default:
        return 'vai-text-left';
    }
  };

  return (
    <div className="vai-w-full vai-overflow-hidden vai-rounded-lg">
      <Table>
        <TableHeader className="vai-bg-gray-100">
          <TableRow>
            {columns.map((column, index) => (
              <TableHead
                key={index}
                className={`vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase vai-p-3 ${getAlignmentClass(
                  column.align,
                )}`}
              >
                {column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.key}
              className="vai-border-b vai-border-gray-200 last:border-b-0"
            >
              {row.cells.map((cell, index) => (
                <TableCell
                  key={index}
                  className={`vai-text-sm vai-text-foreground vai-p-3 ${getAlignmentClass(
                    columns[index]?.align,
                  )}`}
                >
                  {cell}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
